import { parseMarketSymbol } from 'lib/exchange';

type CurrentMarket = {
  quoteSymbol: string;
  baseSymbol: string;
} | null;

export const getCurrentMarketByPath = (path: string): CurrentMarket => {
  // A little hack to initialize market with URL on /trade/XYZ-ABC
  const matched = path.match(/\/trade\/([^-]+-[^\\/]+)/);

  if (matched) {
    return parseMarketSymbol(matched[1]);
  }
  return null;
};
